import { useEffect, useState } from 'react';

// 13 June 2026, 09:00 IST = 13 June 2026, 03:30 UTC
// (month is 0-indexed in Date.UTC, so 5 = June)
export const PS_DIRECTORY_LAUNCH_UTC_MS = Date.UTC(2026, 5, 13, 3, 30, 0);

/**
 * Returns whether the Parichay Sangam Directory has launched (current time
 * has passed the launch instant). Re-checks every 30 s so a page left open
 * across the launch moment will auto-enable without a manual refresh.
 */
export default function usePSDirectoryLaunch() {
  const computeLaunched = () => Date.now() >= PS_DIRECTORY_LAUNCH_UTC_MS;
  const [launched, setLaunched] = useState(computeLaunched);

  useEffect(() => {
    if (launched) return undefined;
    const tick = () => {
      if (computeLaunched()) setLaunched(true);
    };
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, [launched]);

  return launched;
}
